module.exports = __webpack_public_path__ + "img/wallet-background.ccc7af6b.png";